import { createReducer, on } from '@ngrx/store';
import { IGrupo } from 'src/app/interfaces/grupos.interface';
import { GetAsistenciasSuccess, GetGruposSuccess, GetSesionesSuccess } from '../actions/grupos.actions';

export interface IGruposState {
  grupos: IGrupo[];
  asistencias: any[];
  sesiones: any[];
}

export const initialGruposState: IGruposState = {
  grupos: [],
  asistencias: [],
  sesiones: []
};

export const gruposReducers = createReducer(
  initialGruposState,
  on(GetGruposSuccess, (state, { grupos }) => {
    return {
        ...state,
        grupos
    };
  }),
  on(GetAsistenciasSuccess, (state, { asistencias }) => {
    return {
        ...state,
        asistencias
    };
  }),
  on(GetSesionesSuccess, (state, { sesiones }) => {
    return {
        ...state,
        sesiones
    };
  })
);
